import { _ as _extends } from '../../_rollupPluginBabelHelpers-c245b26a.js';
import { forwardRef, useContext, useEffect } from 'react';
import useId from '@indeed/ihl-use-id';
import warnDeprecation from '../../utils/warnDeprecation.js';
import { jsx } from '@emotion/react';
import { Dropdown, DROPDOWN_SIZES, DropdownContext } from '../Dropdown/Dropdown.js';
import { DropdownInput } from '../Dropdown/DropdownInput.js';
import { DropdownMenuList } from '../Dropdown/DropdownMenuList.js';
import { DropdownMenuItem } from '../Dropdown/DropdownMenuItem.js';
import { FormField } from '../FormField/FormField.js';
import '../../utils/warn.js';
import '@indeed/downshift';
import '../../utils/isFunction.js';
import 'react-fast-compare';
import '../../constants/index.js';
import '@indeed/ifl-css';
import '../../utils/styled.js';
import '../../utils/createResponsive.js';
import '@indeed/ifl-icons/ChevronDown';
import '../Dropdown/DropdownTarget.js';
import 'classnames';
import '../../utils/mergeRefs.js';
import '../../hooks/useHasFocus.js';
import '../TouchTarget/TouchTarget.js';
import '../IconWrapper/IconWrapper.js';
import '../Text/Text.js';
import '../../hooks/useAutoPosition.js';
import '../../reach-popover.esm-c19739dd.js';
import 'react-dom';
import '../../hooks/useWindowSize.js';
import '../Dropdown/DropdownPopover.js';
import '../Menu/MenuOverlay.js';
import '../Menu/MenuLabel.js';
import '@indeed/ifl-icons';
import '../Heading/Heading.js';
import '../AccessibleTrap/AccessibleTrap.js';
import 'react-remove-scroll';
import '../AccessibleTrap/FocusTrap.js';
import 'react-focus-lock';
import '../../hooks/useInertA11yBackground.js';
import '../../hooks/useForceUpdate.js';
import '../Menu/MenuItems.js';
import '../../reach-menu-button.esm-22bcdd5f.js';
import '../Menu/MenuItem.js';
import 'focus-visible';
import '../Box/Box.js';
import '../../utils/transition.js';
import '../Flex/Flex.js';
import '@indeed/ifl-icons/Icon';
import '../Label/Label.js';
import '../VisuallyHidden/VisuallyHidden.js';

const parseDropdownItems = items => items.map(item => typeof item === "string" ? {
  label: item,
  value: item
} : item);
const FormFieldWrapper = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    items,
    ...formFieldProps
  } = _ref;
  const itemValues = items.map(i => i.value);
  const dropdownContext = useContext(DropdownContext);
  useEffect(() => {
    const {
      removeSelectedItem
    } = dropdownContext;
    const removed = dropdownContext.items.filter(item => itemValues.indexOf(item) < 0);
    if (dropdownContext.latest.current && dropdownContext.items.length && dropdownContext.items.length !== items.length) {
      dropdownContext.latest.current.items = itemValues;
    }
    removed.forEach(removeSelectedItem);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items]);
  return jsx(FormField, _extends({
    ref: ref
  }, formFieldProps));
});

/**
 * @deprecated The `DropdownFormField` component will be removed in IFL 7.
 * See the IFL 7 preparation guide for more information: https://link.indeed.tech/ifl-7-prep-guide
 */

const DropdownFormField = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
    items,
    dropdownProps,
    dropdownInputProps,
    dropdownMenuListProps = {
      label: "Select an option"
    },
    ...props
  } = _ref2;
  warnDeprecation(deprecationWarning);
  const {
    disabled,
    invalid,
    size
  } = props;
  const menuListItems = items ? parseDropdownItems(items) : [];
  const autoGeneratedHelperTextId = `ifl-DropdownFormField-helperTextId-${useId()}`;
  const helperTextId = props.helperTextId || (props.helperText ? autoGeneratedHelperTextId : undefined);
  const autoGeneratedErrorTextId = `ifl-DropdownFormField-errorTextId-${useId()}`;
  const errorTextId = props.errorTextId || (props.errorText ? autoGeneratedErrorTextId : undefined);
  const ariaDescribedby = ([helperTextId, errorTextId].filter(value => value !== undefined) || []).join(" ");
  return jsx(Dropdown, _extends({
    disabled: disabled,
    invalid: invalid
  }, dropdownProps), _ref3 => {
    let {
      getLabelProps
    } = _ref3;
    const {
      htmlFor,
      id
    } = getLabelProps();
    return jsx(FormFieldWrapper, _extends({
      htmlFor: htmlFor,
      items: menuListItems,
      ref: ref,
      labelProps: {
        id
      },
      helperTextId: helperTextId,
      errorTextId: errorTextId
    }, props), jsx(DropdownInput, _extends({
      size: size,
      "aria-describedby": ariaDescribedby || undefined
    }, dropdownInputProps)), jsx(DropdownMenuList, dropdownMenuListProps, menuListItems.map((itemProps, idx) => jsx(DropdownMenuItem, _extends({
      key: `${id}-${idx}-${itemProps.value}`
    }, itemProps)))));
  });
});
const DROPDOWN_FORM_FIELD_SIZES = DROPDOWN_SIZES;
DropdownFormField.displayName = "DropdownFormField";
const deprecationWarning = `[DropdownFormField] The DropdownFormField component will be removed in IFL 7. See the IFL 7 preparation guide for more information: https://link.indeed.tech/ifl-7-prep-guide`;

export { DROPDOWN_FORM_FIELD_SIZES, DropdownFormField };
